module.exports = __webpack_public_path__ + "static/avatar-mary-d2899635a451bd1c71beaf63074dbe22.png";